import React from 'react';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import AuthLayout from '../modules/AuthLayout';
import MainLayout from '../modules/MainLayout';
import { IntlProvider, addLocaleData } from 'react-intl';
import localeEN from 'react-intl/locale-data/en';
import localeES from 'react-intl/locale-data/es';
import localeFR from 'react-intl/locale-data/fr';
import localeAZ from 'react-intl/locale-data/az';
import localePT from 'react-intl/locale-data/pt';
import localeGE from 'react-intl/locale-data/de';
import localeRU from 'react-intl/locale-data/ru';

import messagesFR from '../translations/fr.json';
import messagesEN from '../translations/en.json';
import messagesES from '../translations/es.json';
import messagesAZ from '../translations/az.json';
import messagesPT from '../translations/pt.json';
import messagesGE from '../translations/ge.json';
import messagesRU from '../translations/ru.json';
import moment from 'utils/moment';
import { BASENAME } from '../constants/RouterConstants';
import AirfieldsConditions from "../modules/AirfieldsConditions/AirfieldsConditions";
import SSDashboardEmbed from '../modules/reports/SSDashboardEmbed';
import Form from '../modules/forms/NewFormAnswer';
import NoiseLog from '../modules/noise_log/NoiseLogForm';
import SafetyManagementHazard from '../modules/sms/SmsHazardForm.jsx';
import SafetyAirportsList from '../modules/sms/SmsAirports.jsx';
import MaintenanceCreatePublic from '../modules/Maintenance/public/MaintenanceCreatePublic';
import Scheduling from '../modules/Badging/Scheduling/Scheduling';
import StandActivityForm from '../modules/gate-management/StandActivityForm';
import CompanyRegistration from '../modules/PermitManagement/Companies/CompanyRegistration';
import TrainingContentList from '../modules/Trainings/public/TrainingContentList';
import ScormContent from '../modules/Trainings/public/ScormContent';
import TrainingContent from '../modules/Trainings/public/TrainingContent';
import WaitListCreate from '../modules/WaitList/WaitListCreate.jsx';
import CustomerResponse from '../modules/WaitList/CustomerResponse.jsx';
import PublicFeedbackForm from '../modules/Maintenance/public/PublicFeedbackForm';
import BadgingLogin from '../modules/Badging/authentication/BadgingLogin';

const messages = {
    es: messagesES,
    en: messagesEN,
    fr: messagesFR,
    az: messagesAZ,
    pt: messagesPT,
    de: messagesGE,
    ru: messagesRU
};

addLocaleData([...localeEN, ...localeES, ...localeFR, ...localeAZ, ...localePT, ...localeGE, ...localeRU]);

const Routes = () => {
  const language = localStorage.getItem('lang') || 'en';
  moment.locale(language);
  const ApiKey = process.env.REACT_APP_GMAPS_KEY;
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${ApiKey}&libraries=places`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
  return (
      <IntlProvider locale={language} messages={messages[language]}>
      <Router basename={BASENAME}>
        <div className="app-container menu-toggle">
          <Switch>
            <Route path="/auth" component={AuthLayout} />
            <Route exact path="/conditions/:airportCode" component={AirfieldsConditions} />
            <Route exact path="/conditions/:id/:airportCode" component={AirfieldsConditions} />
            <Route exact path="/ssreport/:backendId/:dashUri/:auth" component={SSDashboardEmbed} />
            <Route path="/forms/:id/:formKey" component={Form}/>
            <Route path="/noise_log/:id/:airportCode" component={NoiseLog}/>
            <Route path="/safety_management/airports/:id/:airportCode" component={SafetyAirportsList} />
            <Route path="/safety_management/:id/:airportCode" component={SafetyManagementHazard} />
            <Route exact path="/wait_list/:id/:airportCode" component={WaitListCreate} />
            <Route exact path="/non-airfield/:id/:airportCode" component={MaintenanceCreatePublic}/>
            <Route path="/non-airfield/feedback/:installationId/:id/:airportCode" component={PublicFeedbackForm}/>
            <Route exact path="/badge/scheduling/:id/:airportCode" component={Scheduling}/>
            <Route exact path="/badge/scheduling/:installationId/:airportCode/login/" component={BadgingLogin}/>
            <Route path="/gate_managment/stand_activity/:id/:airportCode" component={StandActivityForm}/>
            <Route exact path="/company_registration/:id/:airportCode" component={CompanyRegistration}/>
            <Route exact path="/lms/view/training/:backendId/:airportCode/:trainingId" component={TrainingContentList} />
            <Route exact path="/lms/start/training/:backendId/:airportCode/:trainingId" component={ScormContent} />
            <Route exact path="/lms/start/training/:backendId/:airportCode/:trainingId/:id/:subId" component={TrainingContent} />
            <Route exact path="/public/wait_list/:id/:airportCode/:uniqueId/:customerResponse" component={CustomerResponse}/>
            <Route path="/" component={MainLayout} />
          </Switch>
        </div>
      </Router>
      </IntlProvider>
  );
};


export default Routes;
